import { NavLink } from "react-router-dom";
import { Activity, LayoutDashboard, Layers, GitCompareArrows, Table2, Sparkles, Wallet, Building2, Gauge, Database, Target, FolderCog } from "lucide-react";

const NAV = [
  { to: "/", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/services", label: "Services", icon: Layers },
  { to: "/platforms", label: "Platforms", icon: GitCompareArrows },
  { to: "/campaigns", label: "Campaigns", icon: Table2 },
  { to: "/revenue", label: "Revenue & Planning", icon: Wallet },
  { to: "/ai", label: "AI Advisor", icon: Sparkles },
  { to: "/branches", label: "Branches", icon: Building2 },
];

const MGMT_NAV = [
  { to: "/mgmt", label: "Mgmt Dashboard", icon: Gauge },
  { to: "/daily-funnel", label: "Daily Funnel", icon: Database },
  { to: "/goals", label: "Goals", icon: Target },
  { to: "/master-data", label: "Master Data", icon: FolderCog },
];

export default function Sidebar() {
  return (
    <aside className="hidden lg:flex flex-col w-60 shrink-0 border-r border-white/10 bg-[#0B1120] h-screen sticky top-0">
      <div className="h-16 flex items-center gap-3 px-5 border-b border-white/10">
        <div className="w-9 h-9 rounded-lg bg-[#38BDF8] flex items-center justify-center">
          <Activity className="w-5 h-5 text-[#0F172A]" strokeWidth={2.5} />
        </div>
        <div>
          <p className="font-display text-sm font-semibold leading-tight text-white">Dr. Awish Clinic</p>
          <p className="text-[10px] tracking-[0.2em] uppercase text-slate-500">ROI Command</p>
        </div>
      </div>
      <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
        {NAV.map((n) => {
          const Icon = n.icon;
          return (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`nav-${n.label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#38BDF8]/15 text-[#38BDF8] border border-[#38BDF8]/20"
                    : "text-slate-400 hover:text-white hover:bg-[#1E293B] border border-transparent"}`}>
              <Icon className="w-4 h-4" />
              {n.label}
            </NavLink>
          );
        })}
        <p className="px-3 pt-4 pb-1 text-[10px] tracking-[0.2em] uppercase text-slate-600">Management</p>
        {MGMT_NAV.map((n) => {
          const Icon = n.icon;
          return (
            <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#38BDF8]/15 text-[#38BDF8] border border-[#38BDF8]/20"
                    : "text-slate-400 hover:text-white hover:bg-[#1E293B] border border-transparent"}`}>
              <Icon className="w-4 h-4" />
              {n.label}
            </NavLink>
          );
        })}
      </nav>
      <div className="p-4 border-t border-white/10">
        <div className="rounded-lg bg-[#1E293B] border border-white/10 p-3">
          <p className="text-xs text-slate-400">Powered by</p>
          <p className="text-sm font-medium text-white">AI Strategic Engine</p>
        </div>
      </div>
    </aside>
  );
}
